import { Formatter } from './index';
import { format as formatDate } from 'date-fns';
import { getDateFnsLocale } from './getDateFnsLocale';

export const monthFormatter: Formatter = (value, language) =>
    value instanceof Date || typeof value === 'number'
        ? formatDate(value, 'MMMM', { locale: getDateFnsLocale(language) })
        : null;
